module.exports = __webpack_public_path__ + "static/img/5.28c29ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pczhongfu/5.png
// module id = MMXS
// module chunks = 0